import axios from 'axios';

export const baseURL = window.location.origin === "http://localhost:3000"
    ? "http://127.0.0.1:8000"
    : window.location.origin;

const apiClient = axios.create({
    baseURL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

apiClient.interceptors.response.use(
    response => response,
    error => {
        if (error.response) {
            console.error("API Error:", error.response.status, error.response.data);
        } else if (error.request) {
            console.error("Network Error: No response received", error.request);
        } else {
            console.error("Error:", error.message);
        }
        return Promise.reject(error);
    }
);

export const fetchData = async ({ endpoint, lang, page, type, id, current_Page, per_page } = {}) => {
    const language = lang === "hy" ? "am" : lang;
    let url = `api/${endpoint}`;
    if (type) url += `/${type}`;
    if (page) url += `/${page}`;
    if (id) url += `/${id}`;
    if (lang) url += `/${language}`;

    const params = new URLSearchParams();
    if (current_Page) params.append('page', current_Page);
    if (per_page) params.append('per_page', per_page);

    try {
        const response = await apiClient.get(`${url}${params.toString() ? '?' + params.toString() : ''}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
